import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { baseurl } from '../api';
import { isTextOnly, isRequired, isNumberOnly, maxValue,isSymbolOnly,maxDigit,minDigit,isNotText,isEmail, isPrice, isNumberAndTextOnly} from '../validation';
import authenticatedAxios from '../authenticatedAxios';
import { showAlert } from '../components/common/ExportLabel/Exporterror';
import useRefreshStore from '../store/useRefreshStore';

export const AddPopupContext = createContext();

export const AddPopupProvider = ({ children }) => {
  const [notificationcategory, setNotificationcategory] = useState([]);
  const [emailconfiguration, setEmailconfiguration] = useState([]);
  const [recipientgroup, setRecipientgroup] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [currencysymbols, setCurrencySymbols] = useState([]);
  const [features, setFeatures] = useState([]);
  const [category, setCategories] = useState([]);
  const [plans, setPlans] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countrycodes, setCountrycodes] = useState([]);
  const navigate = useNavigate();
  const [organizationalroles, setOrganizationalroles] = useState([]);
  const [internalroles, setInternalroles] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [translations, setTranslations] = useState([]);
  const [organizations,setOrganizations] = useState([])
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
  const [currentConfig, setCurrentConfig] = useState(null);
  const [popupError, setPopupError] = useState('');
  const [userRolePermissions, setUserRolePermissions] = useState([]);
  const [internalRolePermissions, setInternalRolePermissions] = useState([]);
  const { triggerRefresh } = useRefreshStore();

  // Function to transform API response to select options format
  const transformToOptions = (data, labelKey = 'name', valueKey = 'id') => {
    return data?.map(item => ({
      label: item[labelKey],
      value: item[valueKey]
    })) || [];
  };

  // Unified data fetching function
  const fetchData = async (endpoint) => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}${endpoint}`);
      if (response.data.response_code === 1) {
        return response.data.data;
      }
      return response.data; // Fallback for APIs that don't use response_code
    } catch (error) {
      console.error(`Error fetching data from ${endpoint}:`, error);
      return [];
    }
  };


  // const openAddPopup = (configKey, configData = null, onSave = null) => {
  //   if (configKey === 'Recipient groups') {
  //     navigate('/add-recipient'); // Navigate instead of showing popup
  //     return;
  //   }
  
  //   setCurrentConfig(configKey);
  //   setIsNewPopupOpen(true);
  //   setOnSaveCallback(() => onSave);
  // };

  const openAddPopup = (configKey, configData = null, onSave = null) => {
    if (configKey === 'Recipient Groups') { // Make sure this matches exactly
      navigate('/add-recipient'); // This should match your route
      return;
    }

    setCurrentConfig(configKey);
    setIsNewPopupOpen(true);
  };
  
  useEffect(() => {
    const initializeData = async () => {
      try {
        const [
          recipientgroupData,
          currencyData,
          featureData,
          planData,
          countryData,
          countrycodeData,
          FAQcategoryData,
          languageData,
          // translationsData,
          organizationalroleData,
          internalroleData,
          organizationData,
          permissionsData,

        ] = await Promise.all([
          fetchData('notifications/recipient-groups/'),
          fetchData('currency/active/'),
          fetchData('plans/feature/'),
          fetchData('plans/active/'),
          fetchData('localization/country/active/'),
          fetchData('localization/country/active/'),
          fetchData('faq/category/active/'),
          fetchData('localization/languages/active/'),
          // fetchData('localization/translations/'),
          fetchData('accounts/roles/organizational/active/'),
          fetchData('accounts/roles/internal/active/'),
          fetchData('organization/'),
          fetchData('accounts/permissions/'),
        ]);
        // console.log('Permissions data:', permissionsData);
        const notificationcategoryOptions = transformToOptions(notificationcategory, 'name', 'id');
        setNotificationcategory(notificationcategoryOptions);

        const emailconfigurationOptions = transformToOptions(emailconfiguration, 'name', 'id');
        setEmailconfiguration(emailconfigurationOptions);

        const recipientgroupOptions = transformToOptions(recipientgroupData, 'name', 'id');
        setRecipientgroup(recipientgroupOptions);

        const currencyOptions = transformToOptions(currencyData, 'name', 'id');
        setCurrencies(currencyOptions);

        const currencySymbolOptions = transformToOptions(currencyData, 'symbol', 'id');
        setCurrencySymbols(currencySymbolOptions);

        const organizationalroleOptions = transformToOptions(organizationalroleData, 'name', 'id');
        setOrganizationalroles(organizationalroleOptions);

        const internalroleOptions = transformToOptions(internalroleData, 'name', 'id');
        setInternalroles(internalroleOptions);

        const featureOptions = transformToOptions(featureData, 'name', 'id');
        setFeatures(featureOptions);

        const planOptions = transformToOptions(planData, 'plan_name', 'id');
        setPlans(planOptions);

        const countryOptions = transformToOptions(countryData, 'name', 'id');
        setCountries(countryOptions);

        const countrycodeOptions = transformToOptions(countrycodeData, 'country_code', 'id');
        setCountrycodes(countrycodeOptions);

        const categoryOptions = transformToOptions(FAQcategoryData, 'name', 'id');
        setCategories(categoryOptions);

        const LanguageOptions = transformToOptions(languageData, 'name', 'id');
        setLanguages(LanguageOptions);

        // const TranslationsOptions = transformToOptions(translationsData, 'name', 'id');
        // setTranslations(TranslationsOptions);

        const OrganizationOptions = transformToOptions(organizationData, 'name', 'id');
        setOrganizations(OrganizationOptions);

        setUserRolePermissions(permissionsData || []);
        setInternalRolePermissions(permissionsData || []);



      } catch (error) {
        console.error('Error initializing data:', error);
      }
    };

    initializeData();
  }, []);
  // Popup configurations
  const getPopupConfigs = () => ({
    
    'Category': {
      title: 'New Notification Category',
      buttonName:'Add Category',
      fields: [
        { label: 'Category Name', name: 'name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
        { label: 'Select Email Template', name: 'email_template', type: 'large-select', validators: [isRequired], options: [{ label: 'Features Email', value: 'features_email.html' },{ label: 'Offers Email', value: 'offers_email.html' }]},
        { 
          label: 'Upload Icon', 
          name:'icon',
          type: 'upload-box',
          validators: [isRequired],
        },
      ],
      endpoint: 'notifications/category/'
    },

    'Email Configuration': {
      title: 'New Email Configuration',
      buttonName:'Add Email',
      fields: [

        { label: 'Name',name:'name', type: 'small-input', defaultValue: '', validators: [isRequired]  },
        { label: 'Email Host',name:'email_host', type: 'small-input', defaultValue: '', validators: [isRequired]  },
        { label: 'Email Host User',name:'email_host_user', type: 'small-input', defaultValue: '', validators: [isRequired]  },
        { label: 'Email Host Password',name:'email_host_password', type: 'small-input', defaultValue: '', validators: [isRequired]  },
        { label: 'Email Port',name:'email_port', type: 'small-input', defaultValue: '', validators: [isRequired]  },
        { label: 'Encryption', name: 'state_code', type: 'small-select', options: [{ label: 'SSL', value: 'ssl' }, { label: 'TLS', value: 'tls' }] },
        { label: 'Email Backend',name:'email_backend', type: 'large-input', defaultValue: '', validators: [isRequired]  },

    ],
      endpoint: 'accounts/email-configurations/'
    },    

    'Features': {
      title: 'New Feature',
      buttonName:'Add Feature',
      fields: [
        { label: 'New Feature', name: 'name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
        { label: 'Description', name: 'description', type: 'text', defaultValue: '', validators: [isRequired] }
      ],
      endpoint: 'plans/feature/'
    },
    'Our Plans': {
      title: 'Plan Details',
      buttonName:'Add Plan',
      fields: [
        { label: 'Plan Name', name: 'plan_name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
        { label: 'Display Name', name: 'display_name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
        {
          label: 'Price Monthly',
          name: 'monthly_price',
          select:'currency',
          type: 'input-select-combo-small',
          options: currencysymbols,
          validators:[isRequired,isPrice],
        },
        {
          label: 'Price Yearly',
          name: 'yearly_price',
          select:'currency',
          type: 'input-select-combo-small',
          options: currencysymbols,
          validators:[isRequired,isPrice],
        },
        { label: 'Trial Period / Days', name: 'trial_period', type: 'large-input', defaultValue: '', validators: [isRequired, isNumberOnly, maxValue(365)] },
        {
          label: 'Features',
          name: 'features',
          type: 'features-list',
          allFeatures: features,
          validators:[isRequired],
          defaultValue: []
        }
      ],
      endpoint: 'plans/'
    },
    'FAQ\'s': {
      title: 'New FAQ',
      buttonName:'Add FAQ',
      fields: [
        { label: 'Category', name: 'category', type: 'large-select', validators: [isRequired], options: category, defaultValue: '' },
        { label: 'Question', name: 'question', type: 'text', validators: [isRequired], defaultValue: '' },
        { label: 'Answer', name: 'answer', type: 'text', defaultValue: '', validators: [isRequired] }
      ],
      endpoint: 'faq/faq/'
    },
    'FAQ Categories': {
      title: 'New FAQ Category',
      buttonName:'Add FAQ Category',
      fields: [
        { label: 'Category Name', name: 'name', type: 'large-input', defaultValue: '', validators: [isRequired,isTextOnly] }
      ],
      endpoint: 'faq/category/'
    },
    'Countries': {
      title: 'New Country',
      buttonName:'Add Country',
      fields: [
        { label: 'Country Name', name: 'name', type: 'large-input', validators: [isRequired] },
        { label: 'ISO 3166 Code', name: 'country_code', type: 'large-input', validators: [isRequired] },
        { label: 'Curency', name: 'currency', type: 'large-select', options: currencies, defaultValue: '', validators: [isRequired] },

        {
          label: 'Upload Flag',
          name: 'country_flag',
          type: 'upload-box-country',
          onFileChange: (file) => console.log('Selected file:', file),
          validators: [isRequired]
        },

        { label: 'Plans', name: 'plans', type: 'search-select', options:plans, validators: [isRequired] },

      ],
      endpoint: 'localization/country/'
    },
    'States': {
      title: 'New State',
      buttonName:'Add State',
      fields: [
        { label: 'State Name','name':'name', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly]  },
        { label: 'State Code','name':'state_code', type: 'large-input', defaultValue: '', validators: [isRequired, isTextOnly] },
        {
            label: 'country','name':'country',
            type: 'large-select',
            options: countries,
            defaultValue: '',
            validators:[isRequired]
         
        },
    ],
      endpoint: 'localization/state/'
    },
    'Currencies': {
      title: 'New New Currency',
      buttonName:'Add Currency',
      fields: [
        { label: 'Currency Name', name: 'name', type: 'large-input', validators: [isRequired, isTextOnly] },
        { label: 'Currency Code', name: 'currency_code', type: 'small-input', validators: [isRequired, maxDigit(3), isTextOnly] },
        { label: 'Symbol', name: 'symbol', type: 'small-input', validators: [isRequired, isSymbolOnly] },
        { label: 'Decimal Places', name: 'decimal_places', type: 'small-input', validators: [isRequired, isNumberOnly,minDigit(1),maxDigit(5)] },
        { label: 'Base Exchange Rate in USD', name: 'exchange_rate', type: 'small-input', validators: [ isNumberOnly,minDigit(1),maxDigit(5)] },
    ],
      endpoint: 'currency/'
    },
    'Taxes': {
      title: 'New Tax',
      buttonName:'Add Tax',
      fields: [
        { label: 'Tax Name', name: 'name', type: 'small-input', defaultValue: '',validators: [isRequired] },
        { label: 'Tax Type', name: 'tax_type', type: 'small-select', options: [{ label: 'Fixed Amount', value: 'fixed_amount' },{ label: 'Percentage(%)', value: 'percentage' },], validators:[isRequired]},
        { label: 'Tax Rate', name: 'tax_rate', type: 'small-input', defaultValue: '' ,validators: [isRequired, isNotText,maxDigit(3)]},
        { label: 'Tax Scope', name: 'tax_scope', type: 'small-select', options: [{ label: 'Sales', value: 'sales' }, { label: 'Purchase', value: 'purchase' }], validators:[isRequired] },
        { label: 'Country', name: 'country', type: 'small-select', options: countries, defaultValue: '', validators:[isRequired] },
        { label: 'Effective Date', name: 'effective_date', type: 'small-date', defaultValue: '', validators:[isRequired] },
        { label: 'Expiry Date', name: 'expiry_date', type: 'small-date', defaultValue: '', validators:[isRequired] },
    ],
      endpoint: 'tax/'
    },
    'User Accounts': {
      title: 'New User',
      buttonName:'Add User',
      fields: [
        { label: 'Company name', name:'organization',type: 'small-select', options:organizations,validators: [isRequired] },
        { label: 'User Name',name:'full_name', type: 'small-input',validators:[isTextOnly,isRequired] },
        { label: 'Email', name:'email',type: 'small-input',validators:[isEmail,isRequired]  },
        {
          label: 'Mobile Number',
          type: 'input-select-icon',
          name: 'phone',
          opt:'country_code',
          options:countrycodes,
          onChange: () => {}, 
          validators:[isNumberOnly,isRequired]
        },
        { label: 'User Type',name:'user_type', type: 'small-select', options: [{ label: 'Vansaler', value: 'Vansaler' }, { label: 'Employee', value: 'Employee' }, { label: 'Both', value: 'Both' }],validators: [isRequired]  },

        { label: 'User Role',name:'role', type: 'small-select', options:organizationalroles,defaultValue: '' ,validators: [isRequired]},
        { label: 'Preferred Language',name:'preferred_language', type: 'small-select', options:languages,validators: [isRequired]},
        { label: 'Password', name:'password',type: 'small-input',validators: [isRequired]  },
        { label: 'Upload Photo', type: 'upload-box-country', defaultValue: '',},
      ],
      endpoint: 'accounts/users/organizational/'
    },
    'Internal Users': {
      title: 'New Internal User',
      buttonName:'Add User',
      fields: [
        { label: 'User Name',name:'full_name', type: 'small-input',validators:[isTextOnly,isRequired] },
        { label: 'Email', name:'email',type: 'small-input',validators:[isEmail,isRequired]  },
        {
          label: 'Mobile Number',
          type: 'input-select-icon',
          name: 'phone',
          opt:'country_code',
          options:countrycodes,
          onChange: () => {}, 
          validators:[isNumberOnly,isRequired]
        },
        { label: 'User Role',name:'role', type: 'small-select', options:internalroles,defaultValue: '', validators: [isRequired] },
        { label: 'Preferred Language',name:'preferred_language', type: 'small-select', options:languages, validators: [isRequired]},
        { label: 'Password', name:'password',type: 'small-input', validators: [isRequired]  },
        { label: 'Upload Photo', type: 'upload-box-country', defaultValue: '',},
      ],
      endpoint: 'accounts/users/internal/'
    },


    'Internal User roles': {
      title: 'New Internal User Role',
      buttonName:'Add User Role',
      fields: [
        { label: 'Role Name', name: 'name', type: 'small-input', validators: [isRequired, isTextOnly], defaultValue: '' },
      ],
      endpoint: 'accounts/roles/internal/',
      useCustomPopup: 'AddUserRolePopup',
      customPopupProps: {
        initialTableRows: userRolePermissions,
      }
    },

    'User Roles': {
      title: 'New User Role',
      buttonName:'Add User Role',
      fields: [
        { label: 'Role Name', name: 'name', type: 'small-input', validators: [isRequired, isTextOnly], defaultValue: '' },
      ],
      endpoint: 'accounts/roles/organizational/',
      useCustomPopup: 'AddUserRolePopup',
      customPopupProps: {
        initialTableRows: userRolePermissions,
      }
    },
    'Languages': {
      title: 'New Language',
      buttonName:'Add Language',
      fields: [
        { label: 'Language Name', name: 'name', type: 'large-input', defaultValue: '', validators: [isRequired,isTextOnly] },
        { label: 'ISO 3166 Code', name: 'iso_code', type: 'large-input', defaultValue: '', validators: [isRequired] },
        { label: 'Direction', name: 'direction', type: 'large-select', options: [{ label: 'RTL', value: 'RTL' },{ label: 'LTR', value: 'LTR' },],defaultValue: '', validators: [isRequired]},
      ],
      endpoint: 'localization/languages/'
    },

    'Translations': {
      title: 'New Translation',
      buttonName:'Add Translation',
      fields: [
        { label: 'Language', name:'language', type: 'large-select',options: languages, defaultValue: '',validators: [isRequired] },
        { label: 'Content', name: 'content', type: 'text', defaultValue: '', validators: [isRequired] },
        { label: 'Translated Content', name: 'translated_content', type: 'text', defaultValue: '', validators: [isRequired] },

      ],
      endpoint: 'localization/translations/'
    },
  });

  const openPopup = async (pageName) => {
    const configs = getPopupConfigs();
    const config = configs[pageName];
    
    if (config) {
      // If it's a role popup, fetch fresh permissions data
      if (pageName === 'Internal User roles' || pageName === 'User Roles') {
        try {
          // Fetch fresh permissions data from the single endpoint
          const freshPermissionsData = await fetchData('accounts/permissions/');
          
          // Update the config with the fresh data
          config.customPopupProps = {
            initialTableRows: freshPermissionsData || []
          };
        } catch (error) {
          console.error(`Error fetching fresh permissions for ${pageName}:`, error);
        }
      }
      
      setCurrentConfig({...config, pageName});
      setIsNewPopupOpen(true);
    } else {
      console.error(`No config found for page: ${pageName}`);
    }
  };
    
  

  const closePopup = () => {
    setIsNewPopupOpen(false);
    setCurrentConfig(null);
    setPopupError('')
  };

  // const handleSave = async (formValues) => {
  //   if (!currentConfig) return;
  //   // console.log(formValues)
  //   if (currentConfig.pageName === 'Our Plans') {
  //     const formattedData = {
  //       plan_name: formValues.plan_name,
  //       display_name: formValues.display_name,
  //       trial_period: formValues.trial_period,
  //       features: formValues.features,
  //       monthly_price: parseFloat(formValues.monthly_price?.price || 0),
  //       yearly_price: parseFloat(formValues.yearly_price?.price || 0),
  //       currency: formValues.monthly_price?.currency || formValues.yearly_price?.currency
  //     };

  //     try {
  //       const response = await authenticatedAxios.post(`${baseurl}${currentConfig.endpoint}`, formattedData);
  //       if (response.data.response_code === 1) {
  //         triggerRefresh(currentConfig.pageName);
  //         closePopup();
  //         return true;
  //       }
  //     } catch (error) {
  //       // console.error('Error saving plan:', error);
  //       if (error.response) {
  //         // console.error('Server error response:', error.response.data);
  //       }
  //       return false;
  //     }
  //   }

  //   try {
  //     const response = await authenticatedAxios.post(`${baseurl}${currentConfig.endpoint}`, formValues, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data', 
  //       },
  //     });
  //     if (response.data.response_code === 1) { 
  //       triggerRefresh(currentConfig.pageName);
  //       closePopup();
  //       return true;
  //     }
  //   } catch (error) {
  //     console.error('Error saving data:', error);
  //     return false;
  //   }
  // };

  const handleSave = async (formValues) => {
    if (!currentConfig) return;

    let dataToSend = formValues;
    let config = {};
  
    // Format for 'Our Plans'
    if (currentConfig.pageName === 'Our Plans') {
      dataToSend = {
        plan_name: formValues.plan_name,
        display_name: formValues.display_name,
        trial_period: formValues.trial_period,
        features: formValues.features,
        monthly_price: parseFloat(formValues.monthly_price?.price || 0),
        yearly_price: parseFloat(formValues.yearly_price?.price || 0),
        currency: formValues?.currency
      };
    }
  
    else if (currentConfig.pageName === 'Countries') {
      const formData = new FormData();
      formData.append('name', formValues.name);
      formData.append('country_code', formValues.country_code);
      formData.append('currency', formValues.currency);
      formData.append('country_flag', formValues.country_flag);
      formData.append('timezone', formValues.timezone);
  
      // Append all selected plan values
      formValues.plans.forEach(plan => {
        formData.append('plans', plan.value); // assuming [{label, value}]
      });
  
      dataToSend = formData;
      config.headers = { 'Content-Type': 'multipart/form-data' };
    }
    
    else if (currentConfig.pageName === 'Category') {
      const formData = new FormData();
      formData.append('name', formValues.name);
      formData.append('country_code', formValues.country_code);
      dataToSend = formData;
      config.headers = { 'Content-Type': 'multipart/form-data' };
       if (formValues.icon instanceof File) {
        formData.append('icon', formValues.icon);
      } else if (formValues.icon && typeof formValues.icon === 'object' && formValues.icon.file) {
        // If the icon is an object with a file property
        formData.append('icon', formValues.icon.file);
      }
    }

    try {
      const response = await authenticatedAxios.post(
        `${baseurl}${currentConfig.endpoint}`,
        dataToSend,
        config
      );
      // const response = "hi"
  
      if (response.data.response_code === 1) {
        triggerRefresh(currentConfig.pageName);
        closePopup();
        return true;
      }
      else{
        setPopupError(response?.data?.message || 'Something went wrong!')
      }
    } catch (error) {
      const message = error?.response?.data?.message || 'Something went wrong!';
      setPopupError(message);
      return false;
    }
    
  };
  
  

  const handleSaveUserRole = async (formData, endpoint) => {
    try {
      // Format the data for the role endpoints
      const roleData = {
        name: formData.name,
        permissions: formData.permissions // This contains the selected permission IDs
      };
  
      const response = await authenticatedAxios.post(`${baseurl}${endpoint}`, roleData);
      
      if (response.status >= 200 && response.status < 300) {
        triggerRefresh(currentConfig.pageName);
        closePopup();
        return true;
      }
    } catch (error) {
      console.error('Error saving user role:', error);
      const errorMessage = error.response?.data?.message || 'Failed to save user role';
      showAlert(errorMessage, 'error');
      return false;
    }
  };
  


  return (

    <AddPopupContext.Provider 
    value={{
      isNewPopupOpen,
      currentConfig,
      openPopup,
      closePopup,
      handleSave,
      currencies,
      features,
      category,
      countries,
      organizationalroles,
      internalroles,
      languages,
      openAddPopup,
      handleSaveUserRole,
      userRolePermissions,
      internalRolePermissions,
      popupError,
    }}
  >
    {children}
  </AddPopupContext.Provider>
  );
};
